import { render, staticRenderFns } from "./TeamNews.vue?vue&type=template&id=28a8e4b3&scoped=true"
import script from "./TeamNews.vue?vue&type=script&lang=js"
export * from "./TeamNews.vue?vue&type=script&lang=js"
import style0 from "./TeamNews.vue?vue&type=style&index=0&id=28a8e4b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a8e4b3",
  null
  
)

export default component.exports